import styled from "styled-components";

export default styled.div`
  .cart__item__wrapper {
    max-height: 337px;
    overflow: auto;
    margin-top: 5px;
  }

  .materialUi__dropdown {
    .materialUi__dropdown--toggle {
      height: 36px;
      &.materialUi__dropdown--toggle--active {
        color: #1ebec8 !important;
      }
    }
    .cart--icon {
      font-size: 20px;
    }
    .cart--counter {
      right: 10px;
      position: absolute;
      span {
        background: #1ebec8;
      }
    }

    .materialUi__dropdown--menu {
      width: 350px;
      margin-top: 21px;
      .cart__item--container {
        display: flex;
        border-bottom: 1px solid #ddd;
        box-shadow: unset;
        width: 100%;
        margin-bottom: 10px;
        padding-left: 10px;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 0, 0, 0.04);
        }
        &:last-child {
          margin-bottom: unset;
        }
        .item--link {
          flex: 2 2 auto;
          display: flex;
          &:hover {
            color: unset;
          }
        }
        .item--image {
          width: 111px;
          height: 72px;
        }
      }
      .item--details {
        flex: 1 1 auto;
        display: flex;
        position: relative;
      }
      .item--fields {
        display: flex;
        flex-direction: column;
        height: 100%;
        flex: 1 1 auto;
        padding: 4px 0 4px 10px;
        p {
          font-size: 11px;
          margin-top: unset;
          font-weight: 400;
          letter-spacing: 0.38px;
          line-height: 16px;
          flex: 1 1 auto;
        }

        .item--title {
          color: rgba(0, 0, 0, 0.6);
          width: 150px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .item--cta {
        display: block;
        width: 50px;
        flex: 1;
        padding: 0 10px 0 0;

        align-items: center;
        display: flex;
        flex-direction: column;
        span {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.87);
        }
        .item--remove {
          padding: 4px;
          color: rgba(0, 0, 0, 0.54) !important;
          height: 35px;
          &:hover {
            color: #008183 !important;
          }
          svg {
            font-size: 16px;
          }
        }
      }
      .your-cart {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgb(214, 213, 213);
        padding: 8px 10px 12px;
        height: 50px;
        margin-bottom: 8px;
        .cart--totalItem {
          flex: 1 1 auto;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.87);
          letter-spacing: 1.9px;
          font-weight: 400;
          text-transform: uppercase;
        }

        span {
          color: #666;
          font-weight: 300;
          letter-spacing: 0;
          text-transform: none;
        }
        .subtotal--text {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
      .mini-cart-check-out {
        text-align: center;
        border-top: 1px solid rgb(214, 213, 213);
        margin-top: -1px;
        max-height: 55px;
        p.shopify-error {
          color: ${(props) => props.theme.colors.primary.main}
          font-size: 13px;
          text-transform: none;
          padding: 5px 15px;
          margin-bottom: 0;
        }
        label {
          line-height: 14px;
          padding-top: 20px;
          text-transform: none;
          font-size: 14px;
          a {
            padding: 0;
            height: auto;
            margin: 0;
          }
        }
        button {
          background: #1ebec8;
          border: none;
          color: #fff;
          margin: 10px 0;
          cursor: pointer;
          padding: 5px 20px;
          font-size: 14px;
          &:hover {
            color: #fff !important;
            background: #1ebec8;
          }
        }
      }
    }

    .cart--empty {
      padding: 15px 0;
      text-align: center;
      .cart--message {
        margin-top: 15px;
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 400;
        font-family: 'Mulish';
        font-style: normal;
        line-height: 150%;
        letter-spacing: 0.15px;
        color: #00C3CB;
      }

      .MuiDivider-root {
        margin-top: 15px;
      }
      .cart--search {
        margin-top: 15px;
        button {
          background: ${(props) => props.theme.colors.primary.main};
          color: #fff !important;

          &:hover {
            color: #fff !important;
            background: ${(props) => props.theme.colors.primary.main}
          }
        }
      }
    }
  }
`;
